import script from "./Radio.vue?vue&type=script&setup=true&lang=js"
export * from "./Radio.vue?vue&type=script&setup=true&lang=js"

import "./Radio.vue?vue&type=style&index=0&id=20b2163a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20b2163a"]])

export default __exports__